import axiosInstance from "../helpers/axiosInstance";

export const getReportOaApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptance`, request.data);
    return response.data;
    }

export const getReportOaDetailsCsvDownload = async (request) => {
    const queryParams = new URLSearchParams(request).toString();
    const response = await axiosInstance.get(`staff/reports/oaDetails/csv?${queryParams}`);
    return response.data;
    }

export const getOaConfirmApi = async (product) => {
    const { oaNo, productId } = product.payload;

    const response = await axiosInstance.get(`staff/reports/orderAcceptance/confirmedList`, {
        params: { oaNumber: oaNo, productId }
    });
    return response.data
};

export const getReportOaListApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptance/v2`, request.data)    
    return response.data;
};

export const addMsPoInwardProductsApi = async (request) => {
    const response = await axiosInstance.post(`staff/products/inward`, request.formData);
    return response.data;
    }

export const addReportOaFormListApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptance/updateOaConfirmation`, request.formData);
    return response.data;
    }

export const lisReportSubMenuApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptanceConfirmation`, request.formData);
    return response.data;
    }

export const getOaReportCsvDownload = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptance/v2/csv`, request.formData, { responseType: 'text' });
    return response.data;
    }

export const getOaCsvDownload = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptanceConfirmation/csv`, request.formData, { responseType: 'text' });
    return response.data;
    }

export const getOaConfirmPdfView = async (request) => {
    const response = await axiosInstance.post(`public/oAConfirmation/preview/v2`, request.formData, { responseType: 'text' });
    return response.data;
    }

export const oaDownloadApi = async (request) => {
    const response = await axiosInstance.post(`staff/oAConfirmation/htmls`, request)    
    return response.data;
};

export const oaMsApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptanceConfirmation/inward`, request.formData);
    return response.data;
    }

export const onOaMsInwardApi = async (request) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${request.formData.id}/verifiedProductListForInward`);
    return response.data;
    }

export const oaCsvDownloadApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptance/confirmedList`, request.formData, { responseType: 'text' });
    return response.data;
    }

export const oaMsCsvDownloadApi = async (request) => {
    const response = await axiosInstance.post(`staff/reports/orderAcceptanceConfirmation/inward/csv`, request.formData, { responseType: 'text' });
    return response.data;
    }